import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ResultMethods } from '../resultMethods.types';
import { tipResultItem } from '../Results.css';
import { RenderedTipResult } from './tipMethods.types';
import { stack } from '@/uiPrimitives/layout/stack';
import { HeadingTextBlock } from '@/uiComposites/typography/headings';
import { IconBlock, iconBlockIcon } from '@/sections/iconBlock/IconBlock';
import { asideBlockTypes } from '@/sections/markup/blockNodes/AsideBlockTypes';
import { textStyle } from '@/uiPrimitives/typography/text';
import { TitlePrefix } from '../../_renderers/TitlePrefix';
import { position } from '@/uiPrimitives/layout/position';
import { spaces } from '@/uiPrimitives/layout/space.definitions';

export const TipResultMethods: ResultMethods<RenderedTipResult> = {
	Render: ({ result, headingLevel }) => {
		const blockIcon = asideBlockTypes[result.variation];
		return (
			<IconBlock
				icon={<i className={classes(iconBlockIcon(blockIcon))} />}
				className={classes(tipResultItem, position({ position: 'relative' }))}
			>
				<TitlePrefix
					titlePrefix={result.titlePrefix}
					style={{
						// To put it below the block icon
						insetBlockStart: spaces['5 | betweenParagraphs'],
					}}
				/>
				<div
					className={classes(
						stack({
							rowGap: '5 | betweenParagraphs',
						}),
					)}
				>
					<HeadingTextBlock
						headingLevel={headingLevel}
						size="h3"
						className={classes(textStyle({ color: 'positiveBlue' }))}
					>
						{result.titleText}
					</HeadingTextBlock>
					<div>{result.description}</div>
				</div>
			</IconBlock>
		);
	},
};
